<div *ngIf="showSummary">
  <div class="box-form-ui header container">
    <div class="box-product-summary">
      <picture>
        <img
          [src]="assetsUrl + '/images/cdt/icons/product-summary-icon.svg'"
          alt=""
        />
      </picture>

      <h1>{{ !pendingPSE ? '¡Felicitaciones ' + name + '!' : name }}</h1>
      <p class="copy-summary">
        Te presentamos el resumen del(los) producto(s) que abriste:
      </p>
    </div>
  </div>

  <section class="toast container-card" *ngIf="pendingPSE">
    <em class="icon-info"></em>
    <div class="content">
      <h4>La transacción esta pendiente por confirmar</h4>
      <p>
        Si es rechazada intenta nuevamente transferir tu plata antes de 48 horas
        a través de avvillas.com.co en la sección ahorro e inversión, selecciona
        CDT.
      </p>
    </div>
  </section>

  <section class="box-cards">
    <article id="Account" class="card container-card">
      <header class="header account-type">
        <picture class="image">
          <img [src]="assetsUrl + '/images/cda/icons/wallet-icon.svg'" alt="" />
          <span class="line"></span>
        </picture>
        <h2>
          <strong>CDT</strong>
          Digital <strong>No. {{ cdtAccountNumber }}</strong>
        </h2>
        <span class="line"></span>
      </header>
      <p class="summary-list summary-list-data-row">
        <span><strong>Tu CDT</strong></span>
      </p>
      <p class="summary-list summary-list-data-row term-rate">
        <span>Plazo: {{ cdtTimeTerm }} días</span>
        <span>|</span>
        <span>Tasa: {{ interestRate }}% E.A.</span>
      </p>
      <p class="summary-list summary-list-data-row">
        <span>Inversión:</span>
        <span class="money" [innerHTML]="cdtAmount | currencyFormat:false"></span>
      </p>
      <p class="summary-list summary-list-data-row">
        <span>Ganancias:</span>
        <span class="money">{{simulationData.profit}}</span>
      </p>
      <p class="summary-list summary-list-data-row">
        <span>Retención en la Fuente:</span>
        <span class="money">{{simulationData.retention}}</span>
      </p>
      <p class="summary-list summary-list-data-row divider">
        <span><strong>Recibirás:</strong></span>
        <span class="money">{{simulationData.totalProfit}}</span>
      </p>
      <p
        class="summary-list summary-list-data-row divider"
        id="Founding"
        *ngIf="!pendingPSE"
      >
        <span><strong>Débito desde PSE</strong></span>
      </p>
      <p class="summary-list summary-list-data-column profits-description divider">
        <span><strong>Pago de rendimientos:</strong></span
        ><br />
        <span class="description-value" *ngIf="!officeProfits"
          >{{ terminationSwitch }} en tu cuenta AV Villas{{
            profitsAccount ? ' No. *****' + profitsAccount : ''
          }}</span
        >
        <span class="description-value" *ngIf="officeProfits"
          >{{ terminationSwitch }} en una oficina AV Villas.</span
        >
      </p>
      <ul>
        <li *ngIf="renovationCDT">
          <span>Con renovación automática al vencimiento del CDT.</span>
        </li>
        <li>
          <span
            >Tu CDT se verá reflejado en tus Canales Digitales en máximo
            <strong>5 días hábiles.</strong></span
          >
        </li>
        <li>
          <span
            >Enviaremos a tu correo la Constancia de Depósito emitida por
            Deceval.</span
          >
        </li>
      </ul>
    </article>
  </section>

  <section class="box-cards" *ngIf="digitalProfits">
    <div class="container-card p-0" *ngIf="showOfficeCardAlert">
      <app-alert
        margin="20px 0 20px 0"
        msg="Recuerda que debes recoger tu tarjeta física en cualquier oficina del banco AV Villas a nivel nacional, presentando tu cédula de ciudadanía."
      ></app-alert>
    </div>
    <article id="CdtWithAccount" class="card container-card">
      <header class="header account-type">
        <picture class="image">
          <img [src]="assetsUrl + '/images/cda/icons/wallet-icon.svg'" alt="" />
          <span class="line"></span>
        </picture>
        <h2>
          <strong>Cuenta</strong> Digital
          <strong>No. {{ accountNumber }}</strong>
        </h2>
        <span class="line"></span>
      </header>
      <p class="summary-list summary-list-data-row divider">
        <span><strong>Cuota de manejo:</strong></span>
        <span class="money" [innerHTML]="0 | currencyFormat:false"></span>
      </p>
      <p class="summary-list summary-list-data-row divider tag-aval">
        <img [src]="assetsUrl + '/common/logo/aval_tag.svg'" alt="icon modal tag aval" class="modal__icon">
        <span class="key"><strong>{{ tagAval }}</strong></span>
      </p>
      <div class="summary-list final end">
        <div class="description description-value">
          <span
            >Consulta y usa tu Tag a través de los canales digitales máximo al siguiente día hábil.
          </span>
          <br>
          <br>
          <span class="open-dialog-button" (click)="openTagDialog()" (keydown)="openTagDialog()">Conoce más</span>
        </div>
      </div>
      <div class="summary-list final end">
        <span class="summary-list divider"
          >Tienes <strong>3 retiros gratis al mes</strong> en cajeros de la Red
          Aval
        </span>
        <div class="transfers">
          <picture class="image-icon">
            <img
              [src]="assetsUrl + '/images/cda/icons/money-transfer-icon.svg'"
              alt=""
            />
            <span class="line"></span>
          </picture>
          <p class="title">
            Transferencias gratis a cualquier banco (ACH) desde los Canales Digitales.
          </p>
        </div>
      </div>
    </article>
  </section>

  <p class="text-digital-account container-card" *ngIf="digitalProfits">
    <strong>A partir de ahora podrás empezar a consultar</strong> tus productos
    en nuestros canales digitales.
  </p>

  <app-voucher [data]="dataVoucher"></app-voucher>

  <section class="section-button container-card">
    <a
      class="btn btn-degraded blue"
      href="https://www.avvillas.com.co"
      target="_blank"
      rel="noopener noreferrer"
      >Finalizar</a
    >
  </section>

  <section class="download-voucher">
    <button type="button" (click)="downloadVoucher()">
      <span class="download">Descargar</span>
      <picture class="icon"
        ><img [src]="assetsUrl + '/images/cdt/icons/icon-download.svg'" alt=""
      /></picture>
    </button>
  </section>
</div>
